import Validator from "is_js";
import { isEmpty } from "lodash";


export function addRetailerItem(data) {
  const { retailerName, country } = data || {}
  let errors = {};

  if (Validator.empty(retailerName)) {
    errors.retailerName = "Retailer Name is required"
  }
  if (Validator.empty(country)) {
    errors.country = "Country is required"
  }

  return {
    isValid: isEmpty(errors),
    errors
  };
}
